import checkTypeValidity from '../type-check/check-type-validity.js';

/**
 * @func randomString
 * @param {number} length - The length of the string.
 * @return {string}
 * @desc Creates a random alphanumeric string.
 * ```js
 * randomString(5);
 * // returns "j23mx"
 * ```
 * @memberof module:Random
 * @instance
 */
function randomString(length = 10) {
    if (!checkTypeValidity(['number'], length))
        return '';
    return Array.from(Array(length), () => Math.floor(Math.random() * 36).toString(36)).join('');
}

export { randomString as default };
